//
import React from 'react'

const AppStateContext = React.createContext(null)

export default AppStateContext
